import React from 'react';
import ReactModal from 'react-modal';
import styles from './Modal.module.css';

export default function Modal({
  isOpen,
  children
}: {
  isOpen: boolean;
  children: JSX.Element;
}): React.ReactElement {
  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      className={styles.modal}
      overlayClassName={styles.overlay}
      bodyOpenClassName={styles.modalOpen}
    >
      {children}
    </ReactModal>
  );
}
